import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslatePipe } from '../../../../shared/custom-pipes/translate-pipe/translate.pipe';
import { Globals } from '../../../../../environments/Globals';
import { LoaderService } from '../../../../services/loader/LoaderService';
import { HrBusinessService } from '../../../../services/hr/hr-business.service';
import { BusinessServices } from '../../../../services/singleton/business-services';

import { Employee } from '../../../../models/HR/Employee/employee';
import { EmployeeVisaDetail } from '../../../../models/HR/EmployeeVisaDetail/employeeVisaDetail';
import { EmployeeContactDetail } from '../../../../models/HR/EmployeeContactDetail/employee-contact-detail';
import { FileModel } from '../../../../models/HR/FileModel/file-model.model';
import { EmployeeUsers } from 'src/app/models/HR/EmployeeUsers/employeeUsers';
import { ApplicationCodes } from 'src/app/shared/constent/applicationcodes';

@Component({
    selector: 'app-onboarding',
    templateUrl: './OnBoarding.component.html',
    styles: []
})
export class OnboardingComponent implements OnInit {

    model: Employee = new Employee();
    applicationCodes = new ApplicationCodes();

    IsAutoCode: boolean = false;
    isAutoPrint: boolean = false;
    branchOptions = [];
    departmentOptions = [];
    designationOptions = [];
    gradeOptions = [];
    payGroupOptions = [];
    cityOptions = [];
    areaOptions = [];
    emergencyOptions = [];
    nationalityOptions = [];
    religionOptions = [];

    options = [
        { name: 'Citizen', Id: 1 },
        { name: 'Visa Holder', Id: 2 }
    ];

    statusOptions = [
        { Id: 1, name: 'Onboarding' },
        { Id: 2, name: 'Approved' }
    ];

    constructor(
        private loaderService: LoaderService,
        private hrBusinessService: HrBusinessService,
        private businessService: BusinessServices,
        private toastrService: ToastrService,
        private translate: TranslatePipe,
        private globals: Globals
    ) { }


    ngOnInit() {
        this.initializeModel();
        this.loadDropdownData();
    }

    getStatusName(statusId: number): string {
        const status = this.statusOptions.find(s => s.Id === statusId);
        return status ? status.name : '';
    }

    initializeModel() {
        this.model = new Employee();
        this.model.EmployeeVisaDetails = new EmployeeVisaDetail();
        this.model.ContactDetail = new EmployeeContactDetail();
        this.model.DocumentsList = new Array<FileModel>();
        this.model.EmployeeUser = new EmployeeUsers();
    }

   onDdlChange(value, ddlType) {

        if (ddlType === "1") {
            let selectedItem = this.religionOptions.find(x => x.Id === value);
            if (selectedItem == null)
                selectedItem = this.religionOptions.find(x => x.Name.toLowerCase() === value.toLowerCase());
            if (selectedItem) {
                this.model.ReligionCode = selectedItem.Id;
                this.model.ReligionName = selectedItem.Name;
            }
            else {
                this.model.ReligionCode = '';
                this.model.ReligionName = '';
            }
        }
        else if (ddlType === "2") {
            let selectedItem = this.nationalityOptions.find(x => x.Id === value);
            if (selectedItem == null)
                selectedItem = this.nationalityOptions.find(x => x.Name.toLowerCase() === value.toLowerCase());
            if (selectedItem) {
                this.model.NationalityCode = selectedItem.Id;
                this.model.NationalityName = selectedItem.Name;
            }
            else {
                this.model.NationalityCode = '';
                this.model.NationalityName = '';
            }
        }
            else if (ddlType === "14") {
            let selectedItem = this.options.find(x => x.Id === value);
            if (selectedItem == null)
                selectedItem = this.options.find(x => x.name.toLowerCase() === value.toLowerCase());

            if (selectedItem) {
                this.model.WorkerTypeId = selectedItem.Id;
                this.model.WorkerTypeName = selectedItem.name;
            }
            else {
                this.model.WorkerTypeId = 0;
                this.model.WorkerTypeName = '';
            }
        }

          else if (ddlType === "Status") {
            let selectedItem = this.statusOptions.find(x => x.Id === value);
            if (selectedItem == null)
                selectedItem = this.statusOptions.find(x => x.name.toLowerCase() === value.toLowerCase());

            if (selectedItem) {
                this.model.Status = selectedItem.Id;
                this.model.StatusName = selectedItem.name;
            }
            else {
                this.model.Status = 0;
                this.model.StatusName = '';
            }
        }
    }


    
    loadDropdownData() {
        ;
        this.loaderService.display(true);
        this.businessService.commonService.autoSearch(
            this.applicationCodes.Religions + "," + this.applicationCodes.Nationalities
        ).subscribe((data: any) => {
            console.log('Dropdown API Data:', data);
            this.loaderService.display(false);

            this.nationalityOptions = data.filter(x => x.TblName === this.applicationCodes.Nationalities);
            this.religionOptions = data.filter(x => x.TblName === this.applicationCodes.Religions);

            // Optional: Reset selected values
            this.model.ReligionCode = '';
            this.model.ReligionName = '';
            this.model.NationalityCode = '';
            this.model.NationalityName = '';
        }, error => {
            this.loaderService.display(false);
        });
    }

    saveEmployee(isInserting: boolean) {
        ;
        this.loaderService.display(true);
        this.model.IsAutoNumbering = true;

        if (isInserting) {
            this.model.EmployeeCode = '';
        }

        if (this.model.NoOfChildren == undefined) this.model.NoOfChildren = 0;
        if (this.model.MaritalStatus == undefined) this.model.MaritalStatus = 1;
        if (this.model.EmployeeStatus == undefined) this.model.EmployeeStatus = 1;
        if (this.model.EmployeeType == undefined) this.model.EmployeeType = 1;
        if (this.model.Experience == undefined) this.model.Experience = 0;
        if (!this.model.EmployeeUser)
            this.model.EmployeeUser = new EmployeeUsers();

        if (!this.model.EmployeeVisaDetails)
            this.model.EmployeeVisaDetails = new EmployeeVisaDetail();

        this.model.DOB = String($('#DOB').val());
        this.model.CNICExpiryDate = String($('#CNICExpiryDate').val());

        let dobDate = new Date(this.model.DOB);
        let cnicExpiryDate = new Date(this.model.CNICExpiryDate);

        if (dobDate >= cnicExpiryDate) {
            this.loaderService.display(false);
            this.toastrService.error(this.translate.transform("3894"));
            return;
        }

        this.model.EmployeeUser.EmployeeCode = this.model.EmployeeCode;
        this.model.EmployeeVisaDetails.EmployeeCode = this.model.EmployeeCode;
        this.model.Action = isInserting ? "Save" : "UPDATE";
        this.model.NamesInCulture =
            this.globals.cultureCode + "-<|>-" + this.model.Name;

        this.hrBusinessService.employeeService.SaveRec(this.model)
            .subscribe({
                next: (data: any) => {
                    this.loaderService.display(false);

                    if (data._statusCode === 200) {

                        if (isInserting) {
                            this.model.EmployeeCode = data._obj;
                            this.model.EmployeeUser.EmployeeCode = data._obj;
                            this.model.EmployeeVisaDetails.EmployeeCode = data._obj;
                        }

                        this.toastrService.success(
                            this.translate.transform(data._message)
                        );

                        this.initializeModel();

                        $('#DOB').val('');
                        $('#CNICExpiryDate').val('');
                        $('#JoiningDate').val('');
                    }
                    else {
                        this.toastrService.error(
                            this.translate.transform(data._message)
                        );
                    }
                },
                error: () => {
                    this.loaderService.display(false);
                    this.toastrService.error("Server Error");
                }
            });
    }




}
